export const MyAccount = () => {
	return "";
};
